interface Endpoint {
  path: string;
  method: string;
  params: string[];
}

// interface Endpoints {
//   [key: string]: Endpoint;
// }

export const endpoints = {
  register: {
    path: process.env.NODE_ENV == "development" ? "http://localhost:4000" + "/api/register" : "/api/register",
    method: "POST",
    params: ["name", "surname", "email", "fiscalCode", "administrationId"]
  },
  request: {
    path: process.env.NODE_ENV == "development" ? "http://localhost:4000" + "/api/request" : '/api/request',
    method: "GET",
    params: ["requestToken"],
  },
  initDB: {
    path: process.env.NODE_ENV == "development" ? "http://localhost:4000" + "/api/db/initialize" : "/api/db/initialize",
    method: "GET",
    params: [],
  },
  getAdministrations: {
    path: process.env.NODE_ENV == "development" ? "http://localhost:4000" + "/api/administrations" : "/api/administrations",
    method: "GET",
    params: ["search", "limit"]
  },
  approve: {
    path: process.env.NODE_ENV == "development" ? "http://localhost:4000" + "/api/approve" : "/api/approve",
    method: "POST",
    params: ["requestToken"]

  },
  reject: {
    path: process.env.NODE_ENV == "development" ? "http://localhost:4000" + "/api/reject" : "/api/reject",
    method: "POST",
    params: ["requestToken"]
  },
  gatBackendInfo: {
    path: process.env.NODE_ENV == "development" ? "http://localhost:4000" + "/api/getBackendInfo" : "/api/getBackendInfo",
    method: "GET",
    params: [],
  }

}
